

import { CircleCheck, CircleDot, CircleX } from "lucide-react";
import React from "react";

const DepositManager = ({dataDeposits, handleVerifyDeposit}) => {
    return (
        <>
            <span className="text-2xl font-semibold">Deposits</span>
            <div className="w-full max-h-[500px] bg-white rounded-lg shadow overflow-x-auto">
                <table className="min-w-[900px] w-full border-collapse border my-4 text-xs sm:text-sm">
                    <thead>
                        <tr className="bg-gray-200 text-center sticky top-0 z-1">
                            <th className="border p-2 border-black">Actions</th>
                            <th className="border p-2 border-black">ID</th>
                            <th className="border p-2 border-black">User</th>
                            <th className="border p-2 border-black">Trans</th>
                            <th className="border p-2 border-black">Received</th>
                            <th className="border p-2 border-black">Method</th>
                            <th className="border p-2 border-black">Transaction ID</th>
                            <th className="border p-2 border-black">Status</th>
                            <th className="border p-2 border-black">Created at</th>
                            <th className="border p-2 border-black">Verified at</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Ưu tiên hiển thị Pending */}
                        {[...dataDeposits].sort((a, b) => (b.status === 0 ? 1 : 0) - (a.status === 0 ? 1 : 0)).map((deposit) => (
                            <tr key={deposit.id} className="text-center">
                                <td className="border p-2 flex flex-col sm:flex-row gap-2 justify-center items-center">
                                    {deposit.status === 0 && <button
                                        onClick={() => handleVerifyDeposit(deposit)}
                                        className="bg-green-500 text-black p-1 rounded text-xs sm:text-sm"
                                    >
                                        Confirm
                                    </button>}
                                </td>
                                <td className="border p-2 sticky left-0 bg-white" style={{ zIndex: 2 }}>{deposit.id}</td>
                                <td className="border p-2">{deposit.user.username}(#{deposit.user.id})</td>
                                <td className="border p-2">{deposit.trans_amount.toLocaleString()} {deposit.trans_currency}</td>
                                <td className="border p-2">${deposit.received_amount.toLocaleString()}</td>
                                <td className="border p-2">{deposit.method?.name ?? deposit.method_callback ?? "N/A"}</td>
                                <td className="border p-2 break-all max-w-[120px]">{deposit.trans_id}</td>
                                <td className="border px-4 py-2">
                                    {[
                                        <CircleDot className="text-center text-yellow-500" />,
                                        <CircleCheck className="text-center text-green-500" />,
                                        <CircleX className="text-center text-red-500" />
                                    ][deposit.status]}
                                </td>
                                <td className="border p-2">{new Date(deposit.created_at).toLocaleString()}</td>
                                <td className="border p-2">{deposit.verified_at != null ? new Date(deposit.verified_at).toLocaleString() : "null"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default DepositManager;